export default __webpack_public_path__ + "static/media/dponet-logo-blue.c26cffbd.png";